import classNames from 'classnames';
import { defaultTo, isEmpty } from 'lodash-es';
import { MagnifyingGlass, X } from 'phosphor-react';
import { sanitizeString } from '../../form/form-utils';

type SearchfieldProps = {
  value?: string;
  onValueChange: (newValue?: string) => void;
  className?: string;
};

export const Searchfield = ({ value, onValueChange, className }: SearchfieldProps) => {
  return (
    <label className={classNames('flex items-center tds-search-field', className)}>
      <span className="tds-search-icon mr-100" aria-hidden>
        <MagnifyingGlass />
      </span>
      <span className="sr-only">Volltextsuche</span>
      <input
        onChange={event => onValueChange(sanitizeString(event.target.value))}
        value={defaultTo(value, '')}
        placeholder="Durchsuchen..."
        type="search"
        className="w-full border-none tds-search-value"
      />
      { /* TODO 1335 Der Cancel-Button liegt in einem fixen Div, damit das Layout bei Eingabe eines Suchbegriffs nicht springt.
    Größe und Farbe hart-codiert, damit die Tokens nicht im Output landen */ }
      <button onClick={() => onValueChange(undefined)} type="button" aria-label="Suchbegriff löschen">
        {!isEmpty(value)
          ?
          <X color={'#1E66BD'}/>
          : null }
      </button>
    </label>
  );
};
